module.exports = __webpack_public_path__ + "static/media/fr.11ef8840.svg";